import { ConfigProvider } from 'antd';
import {RouterProvider} from 'react-router-dom';
import './App.css';
import router from './app/routing/AppRoute';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas, far, fab);

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#3c8ebc'
        },
      }}
    >
        <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export default App;
